import type { ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '~/lib/useAuth';

type NavItem = { to: string; label: string; section?: string; adminOnly?: boolean };

const NAV: NavItem[] = [
  { to: '/', label: 'Dashboard', section: 'Operations' },
  { to: '/bookings', label: 'Bookings' },
  { to: '/mailbag', label: 'Mailbag' },
  { to: '/trips', label: 'Trips', section: 'Catalog' },
  { to: '/lodging', label: 'Lodging' },
  { to: '/packages', label: 'Packages' },
  { to: '/anglers', label: 'Anglers', section: 'Business' },
  { to: '/ledger', label: 'The Ledger' },
  { to: '/field-notes', label: 'Field Notes' },
  { to: '/settings/business-info', label: 'Business Info', section: 'Settings' },
  { to: '/settings/booking', label: 'Booking', adminOnly: true },
];

export function Shell({ children }: { children: ReactNode }) {
  const { session, signOut } = useAuth();
  return (
    <div className="trc-shell">
      <aside className="trc-sidebar">
        <Link to="/" className="trc-sidebar-brand">
          <span className="trc-eyebrow">The River Crew</span>
          <span className="trc-osw trc-sidebar-brand-name">Admin</span>
        </Link>
        <nav className="trc-sidebar-nav">
          {NAV.filter(
            ({ adminOnly }) => !adminOnly || session?.user.role === 'admin',
          ).map(({ to, label, section }) => (
            <div key={to}>
              {section && <p className="trc-sidebar-section">{section}</p>}
              <NavLink
                to={to}
                end={to === '/'}
                className={({ isActive }) =>
                  'trc-sidebar-link' + (isActive ? ' trc-sidebar-link--active' : '')
                }
              >
                {label}
              </NavLink>
            </div>
          ))}
        </nav>
        <div className="trc-sidebar-user">
          <span className="trc-sidebar-user-email">{session?.user.email}</span>
          <button type="button" className="trc-sidebar-signout" onClick={signOut}>
            Sign out
          </button>
        </div>
      </aside>
      <main className="trc-main">{children}</main>
    </div>
  );
}
